<template>
  <v-app-bar style="height: 80px; z-index: 0" elevation="0" absolute>
    <div
      v-if="!isLoading && !isLoadingPlan"
      align="left"
      class="bg py-3"
      style="
        background-color: var(--C1);
        cursor: pointer;
        z-index: 2;
        position: fixed;
        top: 0px;
        width: 100vw;
        height: 80px;
      "
    >
      <v-col class="pt-2">
        <v-row justify="center" align="center">
          <v-col cols="auto" v-if="isMobile" class="ml-3 pr-0 pt-0">
            <v-btn
              class=""
              size="25"
              icon="mdi-menu"
              variant="text"
              color="white"
              @click="localDrawerIsOpen = true"
            >
            </v-btn>
          </v-col>
          <v-col cols="" align="left" style="cursor: default" class="pt-0">
            <v-img
              src="@/assets/logo_jauris_white_transparent.webp"
              @click="reloadSite()"
              style="border: none; cursor: pointer"
              :height="isMobile ? '60px' : '60px'"
              :width="isMobile ? '90px' : '200px'"
            ></v-img>
          </v-col>
          <v-col
            cols="auto"
            class="pt-1"
            v-if="groupInformation && groupInformation.post_month_max && !isMobile"
          >
            <v-row justify="center" align="center">
              <v-col class="">
                <v-card
                  variant="flat"
                  class="px-4 py-3"
                  style="
                    background-color: rgba(255, 255, 255, 0.1);
                    color: white;
                    font-weight: bold;
                    border-radius: 40px;
                    font-size: 18px;
                  "
                >
                  Génération disponible (
                  {{
                    groupInformation.article_month_generated_max -
                    groupInformation.article_month_generated
                  }}
                  / {{ groupInformation.article_month_generated_max }} )
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="[0].includes(localSelectedView)" cols="auto" class="pt-0">
            <v-card
              @click="updateData"
              class="buttonV2 pa-1"
              style="cursor: pointer; border-radius: 100%"
              variant="flat"
            >
              <v-icon style="border-radius: 100%; font-size: 40px"> mdi-refresh </v-icon>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </div>
  </v-app-bar>
  <v-dialog v-model="firstLogData.show" width="98%" max-width="1200" persistent>
    <v-card>
      <div
        v-if="userInformation.first_connection == 1"
        style="position: absolute; right: 5px; top: 5px"
      >
        <v-btn
          @click="firstLogData.show = false"
          icon="mdi-close"
          density="compact"
          color="red"
        >
        </v-btn>
      </div>
      <v-col>
        <h2 align="center">
        dd
          <!-- {{ Object.values(groupInformation.web_site_data)[0][0].label }} -->
        </h2>
      </v-col>
      <v-divider class="mb-2"></v-divider>
      <v-col v-if="userInformation.first_connection != 1">
        Bonjour <strong>{{ userInformation.firstname }}</strong
        >, <br /><br />
        Bienvenu chez <strong>Jauris</strong>, boostez votre visibilité en ligne grâce à
        la puissance de l’intelligence artificielle.<br />
        Nous révolutionnons la création de contenu en vous permettant de générer des
        articles de blog <strong>optimisés pour le SEO</strong> en
        <strong>un seul clic</strong>. <br />
        Gagnez un temps précieux tout en améliorant votre
        <strong>positionnement sur Google</strong>. <br />
        Que vous soyez entrepreneur, créateur de contenu ou professionnel du marketing,
        notre solution est conçue pour faire rayonner votre présence en ligne.
      </v-col>
      <v-col v-else class="mx-1 pb-1">
        Connectez Jauris à votre CMS (Shopify ou WordPress) afin de l’utiliser pleinement
        et lui permettre de publier automatiquement et en toute autonomie sur votre site.
      </v-col>
      <v-col>
        <v-card color="var(--C1)" class="pa-3">
          <v-card>
            <v-select
              label="Platform de publication"
              :items="publicationPlatform"
              v-model="
                Object.values(groupInformation.web_site_data)[0][0].publication_platform
              "
              @update:modelValue="
                Object.values(
                  groupInformation.web_site_data
                )[0][0].publication_platform_data = ''
              "
              hide-details
            >
            </v-select>
          </v-card>
          <div
            v-if="
              Object.values(groupInformation.web_site_data)[0][0].publication_platform ==
              'shopify'
            "
          >
            <v-card class="mt-3">
              <v-text-field
                label="URL de votre site (ex : https://mon-site.myshopify.com)"
                v-model="Object.values(groupInformation.web_site_data)[0][0].url"
                hide-details
              ></v-text-field>
            </v-card>
            <v-card class="mt-3">
              <v-text-field
                label="Token de publication (ex : shpat_....)"
                v-model="Object.values(groupInformation.web_site_data)[0][0].compte_token"
                hide-details
              ></v-text-field>
            </v-card>
            <div align="center">
              <v-btn
                v-if="firstLogData.isLoading != true"
                class="mb-3 mt-5 buttonReverse"
                @click="
                  setShopifyBlogData(
                    Object.values(groupInformation.web_site_data)[0][0].compte_token,
                    Object.values(groupInformation.web_site_data)[0][0].url,
                    Object.values(groupInformation.web_site_data)[0][0]
                  )
                "
                >Vérifier mes informations</v-btn
              >
              <div v-else class="mt-2">
                <v-progress-circular
                  color="white"
                  size="50"
                  :width="3"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div>
            <div
              class="mt-3"
              style="color: white"
              v-if="
                Object.values(groupInformation.web_site_data)[0][0]
                  .publication_platform_data &&
                Object.values(groupInformation.web_site_data)[0][0]
                  .publication_platform_data.length > 0
              "
            >
              <span class="mr-2"
                >Informations vérifié valide, liste des blogs trouvé :</span
              >
              <span
                class="mr-2"
                v-for="elem in JSON.parse(
                  Object.values(groupInformation.web_site_data)[0][0]
                    .publication_platform_data
                )"
                :key="elem.id"
              >
                <v-chip style="font-weight: bold; background-color: green; color: white">
                  {{ elem.label }}
                </v-chip>
              </span>
            </div>
            <div v-else style="color: red; font-weight: bold" class="mt-3">
              Informations non vérifié ou non valide, aucun blogs n'a été trouvé, la
              publication ne sera pas disponible. <br />
              Vérifier l'URL de votre site et/ou votre token de publication.
            </div>
          </div>
          <div
            v-else-if="
              Object.values(groupInformation.web_site_data)[0][0].publication_platform ==
              'wordpress'
            "
          >
            <v-card class="mt-3">
              <v-text-field
                label="URL de votre site (ex : https://mon-site/wp-json/wp/v2)"
                v-model="Object.values(groupInformation.web_site_data)[0][0].url"
                hide-details
              ></v-text-field>
            </v-card>
            <v-card class="mt-3">
              <v-text-field
                label="Token de publication (ex : Client:token)"
                v-model="Object.values(groupInformation.web_site_data)[0][0].compte_token"
                hide-details
              ></v-text-field>
            </v-card>
            <div align="center">
              <v-btn
                v-if="firstLogData.isLoading != true"
                class="mb-3 mt-5 buttonReverse"
                @click="
                  setWordpressBlogData(
                    Object.values(groupInformation.web_site_data)[0][0].compte_token,
                    Object.values(groupInformation.web_site_data)[0][0].url,
                    Object.values(groupInformation.web_site_data)[0][0]
                  )
                "
                >Vérifier mes informations</v-btn
              >
              <div v-else class="mt-2">
                <v-progress-circular
                  color="white"
                  size="50"
                  :width="3"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div>
            <div
              class="mt-3"
              style="color: white"
              v-if="
                Object.values(groupInformation.web_site_data)[0][0]
                  .publication_platform_data &&
                Object.values(groupInformation.web_site_data)[0][0]
                  .publication_platform_data.length > 0
              "
            >
              <span class="mr-2">Informations vérifié valide, utilisateur trouvé :</span>
              <v-chip style="background-color: green; color: white">
                {{
                  Object.values(groupInformation.web_site_data)[0][0]
                    .publication_platform_data
                }}
              </v-chip>
            </div>
            <div v-else style="color: red; font-weight: bold" class="mt-3">
              Informations non vérifié ou non valide, aucun blogs n'a été trouvé, la
              publication ne sera pas disponible. <br />
              Vérifier l'URL de votre site et/ou votre token de publication.
            </div>
          </div>
          <!-- {{
          Object.values(groupInformation.web_site_data)[0][0].publication_platform_data
        }} -->
        </v-card>
      </v-col>
      <v-col v-if="userInformation.first_connection != 1">
        <div class="pb-2" style="font-weight: bold">
          Personnaliser votre mot de passe :
        </div>
        <v-card class="mb-3 pr-4" color="var(--C1)">
          <v-text-field
            v-model="firstLogData['p1']"
            label="Nouveau mot de passe"
            hide-details
            :type="showPassword1 ? 'text' : 'password'"
            bg-color="var(--C1)"
            style="color: white"
            :append-icon="showPassword1 ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="togglePasswordVisibility(1)"
          ></v-text-field>
        </v-card>
        <v-card class="pr-4" color="var(--C1)">
          <v-text-field
            v-model="firstLogData['p2']"
            label="Répéter votre mot de passe"
            hide-details
            :type="showPassword2 ? 'text' : 'password'"
            bg-color="var(--C1)"
            style="color: white"
            :append-icon="showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="togglePasswordVisibility(2)"
          ></v-text-field>
        </v-card>
      </v-col>
      <v-col
        v-if="firstLogData.error"
        class="py-0"
        style="color: red; font-weight: bold"
        align="center"
      >
        {{ firstLogData.error }}
      </v-col>
      <v-col v-if="userInformation.first_connection != 1">
        Dites nous en plus sur <strong>{{ groupInformation.name }}</strong> :
        <v-card class="mt-1">
          <v-textarea
            v-model="firstLogData['desc']"
            auto-grow
            rows="2"
            hide-details
            counter="200"
            maxlength="200"
            bg-color="var(--C1)"
            style="color: white"
            label="Entre 50 et 200 caractères"
          >
          </v-textarea>
        </v-card>
        <div class="ml-1 mt-1" style="font-size: 13px; color: var(--C1)">
          Nombre de caractères :
          {{ firstLogData["desc"] == undefined ? 0 : firstLogData["desc"].length }}
        </div>
      </v-col>
      <v-col
        v-if="firstLogData.error2"
        class="py-0"
        style="color: red; font-weight: bold"
        align="center"
      >
        {{ firstLogData.error2 }}
      </v-col>

      <v-col align="center">
        <v-btn class="button" @click="validFirstLogData">
          Valider mes nouvelles informations
        </v-btn>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="closeData.model" width="auto">
    <v-card>
      <v-col align="center">
        <div class="mt-2 mb-3" style="font-weight: bold">
          {{ closeData.label }}
        </div>
        <v-row>
          <v-col align="right">
            <v-btn
              class="button_armo"
              style="background-color: red; color: white"
              variant="flat"
              @click="closeData.model = false"
            >
              Non
            </v-btn>
          </v-col>
          <v-col align="left">
            <v-btn
              class="button_armo"
              style="background-color: green; color: white"
              variant="flat"
              @click="closeData.callback"
            >
              OUi
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="showToken.show" persistent width="98%" max-width="800">
    <v-card color="var(--C1)">
      <v-col class="pb-0" style="position: relative">
        <v-btn
          icon
          density="compact"
          color="red"
          style="position: absolute; right: 10px"
          @click="
            closeData = {
              label: 'Valider la fermeture',
              model: true,
              callback: function () {
                showToken = {};
                closeData = {};
              },
            }
          "
        >
          <v-icon style="color: white">mdi-close</v-icon>
        </v-btn>
        <div style="color: white; font-size: 20px; font-weight: bold">
          Token d'identification {{ showToken.label }}
        </div>
        <div style="color: red; font-weight: bold; font-size: 15px">
          (Enregistrez votre token pour pouvoir l'ajouter dans votre espace platform)
        </div>
      </v-col>
      <v-col class="pt-2">
        <v-card>
          <v-textarea
            rows="1"
            bg-color="white"
            auto-grow
            hide-details
            label="Token"
            v-model="showToken.token"
            readonly
          >
          </v-textarea>
        </v-card>
      </v-col>
    </v-card>
  </v-dialog>
  <v-col class="px-0" style="background-color: red">
    <div
      v-if="isLoading == false"
      :style="{ 'background-color': isMobile ? '' : 'var(--C4)' }"
      style="height: 100vh"
    >
      <drawer-dashboard
        :windowSize="windowSize"
        :localDrawerIsOpen="localDrawerIsOpen"
        :getOperatingSystem="getOperatingSystem"
        :openPublicationSettings="
          function () {
            firstLogData.show = true;
          }
        "
        :setLocalDrawer="
          function (val) {
            localDrawerIsOpen = val;
          }
        "
        :blogListe="blogListe"
        :getUserData="getUserData"
        :groupInformation="groupInformation"
        :userInformation="userInformation"
        :setSelectedVew="setSelectedVew"
        :getLinksFormInformation="getLinksFormInformation"
      ></drawer-dashboard>
      <div
        style="width: 100%; height: 100vh"
        :style="{
          'padding-left': isMobile ? '0px' : '105px',
          'padding-top': '68px',
          background: isMobile ? 'var(--C1)' : 'white',
        }"
      >
        <dataTable
          :getSquedueldata="getSquedueldata"
          :nbrMaxGeneration="nbrMaxGeneration"
          :windowSize="windowSize"
          v-if="blogListe && localSelectedView == 0"
          :updateData="updateData"
          :isLoadingPlan="isLoadingPlan"
          :updateTableAndCloseEditionModal="updateTableAndCloseEditionModal"
          :getOperatingSystem="getOperatingSystem"
          :windowHeight="windowHeight"
          :setIsLoading="setIsLoading"
          :user_squeduel_liste="filter_user_squeduel_liste"
          :getLinksFormInformation="getLinksFormInformation"
          :set_search="set_search"
          :getUserData="getUserData"
          :blogListe="blogListe"
          :groupInformation="groupInformation"
          :userInformation="userInformation"
        >
        </dataTable>
        <settings-view
          v-if="localSelectedView == 2"
          :userInformation="userInformation"
          :groupInformation="groupInformation"
          :getUserData="getUserData"
        ></settings-view>
        <album-view
          v-if="localSelectedView == 4"
          :windowHeight="windowHeight"
          :windowWidth="windowWidth"
          :getOperatingSystem="getOperatingSystem"
          :user_squeduel_liste="filter_user_squeduel_liste"
          :planificateurElements="planificateurElements"
          :groupInformation="groupInformation"
          style="background-color: white; height: 100vh"
          :getUserData="getUserData"
        >
        </album-view>
        <seo-view
          v-if="localSelectedView == 5"
          :windowHeight="windowHeight"
          :windowWidth="windowWidth"
          :user_squeduel_liste="filter_user_squeduel_liste"
          :planificateurElements="planificateurElements"
          :groupInformation="groupInformation"
          :getUserData="getUserData"
        >
        </seo-view>
        <!-- <generator-view v-if="localSelectedView == 6" :blogListe="blogListe" :getSquedueldata="getSquedueldata"  :nbrMaxGeneration="nbrMaxGeneration" :getNbrLoadingArticle="getNbrLoadingArticle" :windowHeight="windowHeight"
                     :updateData="updateData" 
                    :groupInformation="groupInformation">
                </generator-view> -->
      </div>
    </div>
    <div v-else align="center">
      <basic-loading></basic-loading>
    </div>
  </v-col>
  <v-snackbar v-model="snackData.show" color="green" timeout="10000">
    <v-col style="font-size: 19px; font-weight: normal" class="pa-1" align="center">
      {{ snackData.label }}
    </v-col>
  </v-snackbar>
</template>

<script>
import {
  ref,
  onMounted,
  onUnmounted,
  // watch
} from "vue";

import dataTable from "@/view/view-table.vue";
import SettingsView from "@/view/view-settings.vue";
import AlbumView from "@/view/view-album.vue";
import SeoView from "@/view/view-seo.vue";
// import GeneratorView from '@/view/view-generator.vue'

import DrawerDashboard from "@/components/dashboard/dashboard-drawer.vue";
import BasicLoading from "@/components/basic/basic-loading.vue";

import engine from "@/core/index";
import { useRouter } from "vue-router";

export default {
  data() {
    return {
      publicationPlatform: ["shopify", "wordpress"],
      showPassword1: false,
      showPassword2: false,
    };
  },
  setup() {
    const firstLogData = ref({});
    const nbrMaxGeneration = ref(3);
    const closeData = ref({});
    const showToken = ref({});
    const snackData = ref({});
    const windowSize = ref({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    const localSelectedView = ref(0);
    const router = useRouter();
    const userInformation = ref({});
    const groupInformation = ref({});
    const user_squeduel_liste = ref(undefined);
    const searh_value = ref(undefined);
    const isLoadingPlan = ref(false);
    const isLoading = ref(false);
    const blogListe = ref(undefined);
    const modalIsOpen = ref({});
    const modalData = ref(undefined);
    const localDrawerIsOpen = ref(undefined);
    const windowHeight = ref(0);
    const windowWidth = ref(0);

    const updateWindowSize = () => {
      windowSize.value = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    };

    const setIsLoading = function (val, label) {
      isLoadingPlan.value = val;
      if (label) {
        snackData.value = {
          show: true,
          label,
        };
      }
    };

    const planificateurElements = ref([
      {
        title: "Shopify",
        key: "Shopify",
        icon: "mdi-shopping",
        color: "#CFD8DC",
        modalKey: "creatShopifyArticle",
        img: "shopify4.webp",
      },
      {
        title: "Wordpress",
        key: "Wordpress",
        icon: "mdi-shopping",
        color: "#CFD8DC",
        modalKey: "",
        img: "wordpress.webp",
      },
    ]);

    const updateTableAndCloseEditionModal = function () {
      getSquedueldata();
      modalIsOpen.value = {};
    };

    const getSquedueldata = function () {
      engine.get_user_squeduel_by_token(function (data) {
        if (data.state == 200) {
          user_squeduel_liste.value = data.data;
        }
      });
    };

    const getBlogListe = function () {
      blogListe.value = [];

      for (const [key, value] of Object.entries(groupInformation.value.web_site_data)) {
        for (let i = 0; i < value.length; i++) {
          let tmp = value[i];
          tmp["platform"] = key;
          blogListe.value.push(tmp);
        }
      }
    };

    const getUserData = function (callback) {
      engine.get_user_info_by_token(function (data) {
        if (data.state == 200) {
          userInformation.value = data.data[0];
          userInformation.value.settings = JSON.parse(userInformation.value.settings);

          if (userInformation.value.klaviyo && userInformation.value.klaviyo.length > 0)
            engine.set_klaviyo_event(
              userInformation.value.klaviyo,
              "Ouverture du manager.jauris.com"
            );
          engine.get_group_by_user_id(userInformation.value.group_id, function (data2) {
            if (data2.state == 200) {
              groupInformation.value = data2.data;
              groupInformation.value.templates = JSON.parse(
                groupInformation.value.templates
              );
              groupInformation.value.users = JSON.parse(groupInformation.value.users);
              groupInformation.value.web_site_data = JSON.parse(
                groupInformation.value.web_site_data
              );
              groupInformation.value.album_data = JSON.parse(
                groupInformation.value.album_data
              );

              if (
                userInformation.value &&
                (userInformation.value.first_connection == null ||
                  userInformation.value.first_connection != 1)
              ) {
                firstLogData.value["show"] = true;
                firstLogData.value["desc"] =
                  groupInformation.value.entreprise_description;
              }

              if (
                groupInformation.value.proposition_data &&
                groupInformation.value.proposition_data.length > 0
              )
                groupInformation.value.proposition_data = JSON.parse(
                  groupInformation.value.proposition_data
                );
              if (
                groupInformation.value.proposition_questions &&
                groupInformation.value.proposition_questions.length > 0
              )
                groupInformation.value.proposition_questions = JSON.parse(
                  groupInformation.value.proposition_questions
                );

              getBlogListe();
              if (callback != undefined) {
                callback();
              }
            } else {
              localStorage.clear();
              router.push({
                name: "login",
              });
            }
          });
        } else {
          localStorage.clear();
          router.push({
            name: "login",
          });
        }
      });
    };

    onMounted(() => {
      window.addEventListener("resize", updateWindowSize);
      engine.is_user_token_valid(function (data) {
        if (data.state == 200) {
          getSquedueldata();
          getUserData();
          // isLoading.value = false
        } else {
          localStorage.clear();
          router.push({
            name: "login",
          });
        }
      });
    });

    onUnmounted(() => {
      window.removeEventListener("resize", updateWindowSize);
    });

    return {
      windowSize,
      user_squeduel_liste,
      modalIsOpen,
      modalData,
      updateTableAndCloseEditionModal,
      isLoading,
      userInformation,
      groupInformation,
      searh_value,
      localSelectedView,
      planificateurElements,
      getUserData,
      getSquedueldata,
      blogListe,
      snackData,
      localDrawerIsOpen,
      windowHeight,
      windowWidth,
      setIsLoading,
      isLoadingPlan,
      showToken,
      closeData,
      nbrMaxGeneration,
      firstLogData,
    };
  },
  computed: {
    getNbrLoadingArticle() {
      let nbr = 0;

      if (this.user_squeduel_liste && this.user_squeduel_liste.length > 0)
        nbr = this.user_squeduel_liste.filter((val) => val.isGenerate == 0).length;

      return nbr;
    },
    getOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
        return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "IOS";
      }

      return "unknown";
    },
    getLinksFormInformation() {
      if (this.userInformation && this.userInformation.settings) {
        let settingsLinksTab = {
          show_link_interne: { value: 0, label: "Lien interne", background: "var(--BG)" },
          show_link_externe: { value: 1, label: "Lien externe", background: "var(--BG)" },
          show_green_liste: { value: 3, label: "Lien mis en avant", background: "green" },
          show_red_liste: { value: 2, label: "Lien bloqué", background: "red" },
        };

        let linksSettingsToShow = [];

        for (const [key, value] of Object.entries(settingsLinksTab)) {
          if (this.userInformation.settings[key] == true) linksSettingsToShow.push(value);
        }

        return { value: linksSettingsToShow };
      } else return { value: [] };
    },
    isMobile() {
      return this.$vuetify.display.mobile;
    },
    filter_user_squeduel_liste() {
      if (this.user_squeduel_liste && this.user_squeduel_liste.length != 0) {
        let filter_user_squeduel_liste = this.user_squeduel_liste;

        // if (this.selectedBlog && this.selectedBlog.blog_id)
        //     filter_user_squeduel_liste = this.user_squeduel_liste.filter((val) => val.blog_id == this.selectedBlog.blog_id)
        // else
        //     filter_user_squeduel_liste = this.user_squeduel_liste

        if (this.searh_value == undefined) {
          return filter_user_squeduel_liste;
        } else {
          filter_user_squeduel_liste = this.user_squeduel_liste.filter((val) =>
            val.title.toUpperCase().includes(this.searh_value.toUpperCase())
          );
          return filter_user_squeduel_liste;
        }
      } else {
        return [];
      }
    },
  },
  mounted() {
    let that = this;

    this.onResize();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.onResize();

    setInterval(function () {
      that.updateData();
      // }, 60 * 1000);
    }, 120 * 1000);

    let query = this.$route.query;

    if (query.code) {
      this.showToken = {
        show: true,
        token: query.code,
        label: "LinkedIn",
      };
    }

    if (query.show) {
      this.localSelectedView = query.show;
    }

    this.$router.replace({ query: null });
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    setWordpressBlogData(token, url, rep) {
      let that = this;
      that.firstLogData.isLoading = true;
      engine.check_wordpress_credentials(token, url, function (res) {
        console.log("check_wordpress_credentials", res);
        if (res.state == 200) {
          rep.publication_platform_data = res.data.slug + " - " + res.data.name;
        } else rep.publication_platform_data = "";
        that.firstLogData.isLoading = false;
      });
    },
    setShopifyBlogData(token, url, rep) {
      let that = this;
      that.firstLogData.isLoading = true;
      engine.get_shopify_blogs_ids(token, url, function (res) {
        if (res.state == 200) {
          rep.publication_platform_data = JSON.stringify(res.data);
        } else rep.publication_platform_data = "";
        that.firstLogData.isLoading = false;
      });
    },
    sendNewConfig(newConfig) {
      let that = this;
      newConfig = JSON.parse(JSON.stringify(newConfig));

      for (const [key, value] of Object.entries(newConfig)) {
        if (typeof value == "object") {
          newConfig[key] = JSON.stringify(value);
        }
      }

      engine.update_group_config(this.groupInformation.id, newConfig, function () {
        that.updateData();
      });
    },
    validFirstLogData() {
      let that = this;
      function verifierMotDePasse(mdp1, mdp2) {
        if (mdp1 == undefined || mdp2 == undefined) {
          return "Les deux mots de passe doivent être remplis.";
        }
        if (mdp1 !== mdp2) {
          return "Les mots de passe ne sont pas identiques.";
        }
        if (mdp1.length < 8) {
          return "Le mot de passe doit contenir au moins 8 caractères.";
        }
        if (!/[A-Z]/.test(mdp1)) {
          return "Le mot de passe doit contenir au moins une majuscule.";
        }
        if (!/[a-z]/.test(mdp1)) {
          return "Le mot de passe doit contenir au moins une minuscule.";
        }
        if (!/[0-9]/.test(mdp1)) {
          return "Le mot de passe doit contenir au moins un chiffre.";
        }
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(mdp1)) {
          return "Le mot de passe doit contenir au moins un caractère spécial.";
        }
        return true;
      }

      if (that.userInformation.first_connection == 1) {
        this.sendNewConfig(this.groupInformation);
        this.firstLogData = {};
        this.snackData = {
          show: true,
          label: "L’ensemble de vos modifications a bien été pris en compte.",
        };
      } else {
        let verif = verifierMotDePasse(this.firstLogData.p1, this.firstLogData.p2);
        if (verif != true) {
          this.firstLogData.error = verif;
        } else {
          this.firstLogData.error = undefined;
          if (
            this.firstLogData.desc == undefined ||
            this.firstLogData.desc.length == 0 ||
            this.firstLogData.desc.length < 50
          )
            this.firstLogData.error2 =
              "La description de votre marque est obligatoire et doit contenir au minimum 50 caractères.";
          else {
            this.firstLogData.error2 = undefined;
            this.sendNewConfig(this.groupInformation);
            engine.set_first_log_data(
              this.userInformation.group_id,
              this.userInformation.user_id,
              this.firstLogData,
              function () {}
            );
            this.firstLogData = {};
            this.snackData = {
              show: true,
              label:
                "Merci pour ces précisions. Bonne génération d’articles avec Jauris !",
            };
          }
        }
      }
    },
    togglePasswordVisibility(type) {
      if (type == 1) {
        this.showPassword1 = !this.showPassword1;
      } else this.showPassword2 = !this.showPassword2;
    },
    reloadSite() {
      // this.$router.go('/')
      location.reload();
    },
    updateData() {
      this.getSquedueldata();
      this.getUserData();
    },
    setSelectedVew(viewId) {
      this.localSelectedView = viewId;
    },
    openModalCreation(modalKey) {
      this.modalIsOpen[modalKey] = true;
    },
    set_search(value) {
      this.searh_value = value;
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    },
  },
  components: {
    SeoView,
    AlbumView,
    dataTable,
    SettingsView,
    DrawerDashboard,
    BasicLoading,
    // GeneratorView
  },
};
</script>

<style></style>
